<template>
  <div class="payment-form">

    <!-- Registration / Name (read-only) -->
    <v-layout row wrap>
      <v-flex xs12 sm6 class="pr-sm-3">
        <div class="field-label">Registration No</div>
        <v-text-field
          v-model="payment.company_no"
          disabled
          outline
          prepend-inner-icon="fingerprint"
          class="form-input form-input--readonly"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6>
        <div class="field-label">School Name</div>
        <v-text-field
          v-model="payment.company_name"
          disabled
          outline
          prepend-inner-icon="school"
          class="form-input form-input--readonly"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <!-- Date pickers -->
    <v-layout row wrap>
      <v-flex xs12 sm6 class="pr-sm-3">
        <div class="field-label">Last Payment Date</div>
        <v-menu
          ref="statDate"
          lazy
          :close-on-content-click="false"
          v-model="startDateMenu"
          transition="scale-transition"
          offset-y
          full-width
          :nudge-bottom="-22"
          max-width="290px"
          :return-value.sync="last_payment_date"
        >
          <v-text-field
            slot="activator"
            v-model="last_payment_date"
            outline
            append-icon="event"
            readonly
            class="form-input"
            placeholder="Select date"
          ></v-text-field>
          <v-date-picker v-model="last_payment_date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="secondary" @click="startDateMenu = false">Cancel</v-btn>
            <v-btn depressed color="primary" class="picker-ok-btn" @click="$refs.statDate.save(last_payment_date)">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-flex>

      <v-flex xs12 sm6>
        <div class="field-label">Expiry Date</div>
        <v-menu
          ref="endDate"
          lazy
          :close-on-content-click="false"
          v-model="endDateMenu"
          transition="scale-transition"
          offset-y
          full-width
          :nudge-bottom="-22"
          min-width="290px"
          :return-value.sync="exp_date"
        >
          <v-text-field
            slot="activator"
            v-model="exp_date"
            outline
            append-icon="event"
            readonly
            class="form-input"
            placeholder="Select date"
          ></v-text-field>
          <v-date-picker v-model="exp_date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="secondary" @click="endDateMenu = false">Cancel</v-btn>
            <v-btn depressed color="primary" class="picker-ok-btn" @click="$refs.endDate.save(exp_date)">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>

    <!-- Status -->
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <div class="field-label">Subscription Status</div>
        <v-select
          :items="status"
          v-model="e1"
          outline
          item-text="type"
          item-value="in"
          class="form-input"
          @change="type(e1)"
        ></v-select>
      </v-flex>
    </v-layout>

    <!-- Actions -->
    <div class="form-actions">
      <v-btn
        depressed
        color="primary"
        class="submit-btn"
        @click="createCompany"
      >
        <v-icon left small>save</v-icon>
        Save Payment Record
      </v-btn>
    </div>
  </div>
</template>

<script>
import APIPayment from "@/mixins/APIPayment";
export default {
  components: {},
  mixins: [APIPayment],
  data() {
    return {
      payment: {},
      date: null,
      startDateMenu: false,
      last_payment_date: null,
      endDateMenu: false,
      exp_date: null,
      status: [
        { type: "Active", val: "1" },
        { type: "Deactive", val: "2" }
      ],
      e1: "Active"
    };
  },
  computed: {
    queriedUrlId() {
      let url = window.location.href.split("check/");
      return url[1];
    }
  },
  created() {
    this.restoreFrom();
  },
  methods: {
    createCompany: async function() {
      this.payment.exp_date = this.exp_date;
      this.payment.last_payment_date = this.last_payment_date;
      try {
        await this.putPayment(this.payment);
        this.$router.push("/payments");
        this.$toast.success("Payment record updated.", "Success", { position: "topCenter" });
      } catch (error) {
        this.$toast.error("Failed to submit details", "Error", { position: "topCenter" });
      }
    },
    restoreFrom: async function() {
      if (this.$route.params.object !== undefined) {
        this.payment = this.$route.params.object;
        this.exp_date = this.$route.params.object.exp_date;
        this.last_payment_date = this.$route.params.object.last_payment_date;
      } else if (this.$route.params.object === undefined && this.queriedUrlId !== "0") {
        try {
          this.payment = await this.getCompanyById(this.queriedUrlId);
          this.exp_date = this.payment.exp_date;
          this.last_payment_date = this.payment.last_payment_date;
        } catch (error) {
          this.$toast.error("Cannot get details!", "Error", { position: "topCenter" });
        }
      }
    }
  }
};
</script>

<style scoped lang="css">
.payment-form {
  padding: 4px 0;
}

.payment-form >>> .v-layout {
  align-items: flex-start;
}

.field-label {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.form-input >>> .v-input__slot {
  align-items: center !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  display: flex !important;
  min-height: 44px !important;
  margin-bottom: 4px !important;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.form-input >>> .v-text-field__slot,
.form-input >>> .v-select__slot {
  align-items: center !important;
  display: flex !important;
  min-height: 44px !important;
}

.form-input--readonly >>> .v-input__slot {
  background: #f8fafc !important;
}

.form-input >>> .v-input__prepend-inner,
.form-input >>> .v-input__append-inner {
  align-self: center !important;
  margin-top: 0 !important;
}

.form-input >>> input {
  align-self: center !important;
  height: 44px !important;
  line-height: 20px !important;
  margin-top: 0 !important;
  padding: 0 !important;
}

.form-input >>> .v-select__selections {
  align-items: center !important;
  display: flex !important;
  line-height: 20px !important;
  min-height: 44px !important;
  padding: 0 !important;
}

.form-input >>> .v-select__selection {
  line-height: 20px !important;
  margin: 0 !important;
}

.form-input >>> .v-text-field__details {
  margin-bottom: 0 !important;
  min-height: 18px !important;
  padding: 0 12px !important;
}

.form-input >>> .v-messages {
  min-height: 16px !important;
}

.form-input >>> .v-input__slot:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05) !important;
}

.picker-ok-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 8px !important;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 12px;
}

.submit-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 10px !important;
  height: 42px !important;
  padding: 0 24px !important;
  letter-spacing: 0.2px !important;
  box-shadow: 0 2px 8px rgba(21, 101, 192, 0.3) !important;
}
</style>
